import { Component, OnInit } from '@angular/core';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { IndustryProductID } from 'src/app/model/industry';

@Component({
    selector: 'ms-magoweb-dashboard',
    templateUrl: './magoweb-dashboard.component.html',
    styleUrls: ['./magoweb-dashboard.component.scss'],
})
export class MagowebDashboardComponent implements OnInit {
    public edition: string = 'pro';
    public productID: string = IndustryProductID.MW;

    constructor(public navigateService: NavigateService, private magoWebService: MagoWebService) {
        this.magoWebService.edition = this.edition;
    }
    ngOnInit(): void {}

    public navigate() {
        this.navigateService.goToManagement();
    }

    public navigateToHome() {
        this.navigateService.goToHomePage();
    }
}
